import { SharedPagedRequest } from "@sharedcommon/model/shared-page-request.model";

export class SpeciesFilterDto extends SharedPagedRequest {
  /** the code to search (in mode defined in TextMatchMode present in paged request) */
  code: string;
  /** the label to search (in mode defined in TextMatchMode present in paged request) */
  label: string;
  /* To test if the analysis code is included in the list */
  inCodes: string;
}